<template>
  <div class="container">
    <div class="project-detail">
      <!-- 播放器 -->
      <div class="scratch-player">
        <iframe
          :src="
            workInfo.workFile
              ? '/scratch3/player.html?projectUrl=' + workInfo.workFileKey_url
              : 'about:blank'
          "
          id="player"
          frameborder="0"
          width="100%"
          height="100%"
          scrolling="no"
        ></iframe>
      </div>

      <!-- 作品信息 -->
      <div class="project-info">
        <a-row type="flex" justify="space-around">
          <a-col :span="4">
            <a-avatar
              shape="square"
              class="avatar"
              :size="60"
              :src="workInfo.avatar_url"
            />
            <p>{{ workInfo.realname || workInfo.username }}</p>
          </a-col>
          <a-col :span="14">
            <div class="project-meta">
              <h2 class="title">{{ workInfo.workName }}</h2>
              <p class="time">{{ workInfo.createTime }}</p>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="project-op">
              <a-icon type="eye" theme="twoTone" />
              <span class="gap">{{ workInfo.viewNum }}</span>

              <a-icon type="like" theme="twoTone" @click="starWork" />
              <span class="gap">{{ workInfo.starNum }}</span>

              <a-popover title="微信扫一扫手机体验和分享" v-if="false">
                <template slot="content">
                  <qrcode :value="getShareUrl()" :size="200" level="H"></qrcode>
                </template>
                <a-icon type="mobile" theme="twoTone" />
              </a-popover>
            </div>
          </a-col>
        </a-row>
      </div>

      <!-- 评论区 -->
      <div class="project-comment" v-if="false">
        <div class="publish">
          <a-row type="flex" justify="space-between">
            <a-col span="3" class="comment-user">
              <a-avatar
                shape="square"
                :size="60"
                icon="user"
                :src="avatarUrl"
              />
              <p>
                {{ token ? nickname() : "未登录" }}
              </p>
            </a-col>
            <a-col :span="16">
              <a-textarea
                v-model="commentContent"
                :rows="5"
                :maxLength="500"
                placeholder="说说这个作品怎么样吧"
              ></a-textarea>
            </a-col>
            <a-col :span="4">
              <div class="comment-btn">
                <a-button :disabled="!token" type="dashed" @click="comment"
                  >发表评论</a-button
                >
              </div>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-list
          class="comment-list"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无评论' }"
          :data-source="comments"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-comment :author="item.realname || item.username">
              <a-avatar
                shape="square"
                :size="40"
                slot="avatar"
                icon="user"
                :src="item.avatar_url"
              />
              <p class="comment-content" slot="content">
                {{ item.comment }}
              </p>
              <a-tooltip
                slot="datetime"
                :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
              >
                <span>{{ moment(item.createTime).fromNow() }}</span>
              </a-tooltip>
            </a-comment>
          </a-list-item>
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px',
            }"
          >
            <a-spin v-if="loadingMore" />
            <a-button type="link" v-else @click="workComments">
              加载更多
            </a-button>
          </div>
        </a-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { getAction, postAction, getFileAccessHttpUrl } from "@/api/manage";
import { mapGetters } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import QrCode from "@/components/tools/QrCode";
import moment from "moment";
export default {
  name: "WorkDetail",
  components: {
    qrcode: QrCode,
  },
  data() {
    return {
      workId: "",
      workInfo: {},
      token: "",
      commentContent: "",
      showLoadingMore: true,
      loadingMore: false,
      commentsPage: 0,
      comments: [],
    };
  },
  created() {
    this.workId = this.$route.query.id;
    this.getWorkInfo(this.workId);
    this.token = Vue.ls.get(ACCESS_TOKEN);
    console.log(this.getFileAccessHttpUrl(this.avatar()));
    console.log(this.nickname());
  },
  mounted() {
    var that = this;
    //scratch全屏
    document.addEventListener("scratchFullScreen", function (e) {
      that.launchIntoFullscreen(document.getElementById("player"));
    });
    //scratch退出全屏
    document.addEventListener("scratchUnFullScreen", function (e) {
      that.exitFullscreen();
    });
    document.addEventListener("scratchInit", function (e) {
      var p = document.getElementById("player");
      var s = p.contentDocument.getElementById("scratch");
      s.addEventListener("click", () => {
        p.focus();
      });
    });
  },
  computed: {
    avatarUrl() {
      return this.$store.state.user.info && this.$store.state.user.info.avatar
        ? "https://cast-files.oss-cn-beijing.aliyuncs.com/" +
            this.$store.state.user.avatar
        : "/img/avatar.png";
    },
  },
  methods: {
    ...mapGetters(["nickname", "avatar", "userInfo"]),
    moment,
    getFileAccessHttpUrl,
    getWorkInfo(workId) {
      getAction("/teaching/teachingWork/studentWorkInfo?workId=" + workId).then(
        (res) => {
          if (res.success) {
            this.workInfo = res.result;
            this.workComments();
          } else {
            this.$message.error("作品获取失败");
          }
        }
      );
    },
    starWork() {
      getAction("/teaching/teachingWork/starWork?workId=" + this.workId).then(
        (res) => {
          if (res.success) {
            if (res.message == "点赞成功") {
              this.workInfo.starNum += 1;
            }
            this.$message.success(res.message);
          }
        }
      );
    },
    workComments() {
      this.commentsPage += 1;
      this.loadingMore = true;
      getAction("/teaching/comment/queryCommentBySourceId", {
        id: this.workId,
        page: this.commentsPage,
      }).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0 && this.commentsPage > 1) {
          this.$message.info("已加载完啦！");
        } else {
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        postAction("/teaching/comment/saveComment", {
          sourceType: '1',
          sourceId: this.workId,
          comment: this.commentContent,
        }).then((res) => {
          if (res.success) {
            this.comments.unshift({
              comment: this.commentContent,
              realname: this.nickname(),
              avatar_url: this.getFileAccessHttpUrl(this.avatar()),
              createTime: new Date(),
            });
            this.commentContent = "";
            this.$message.success(res.message);
          }
        });
      }
    },
    getShareUrl() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/scratch3/scratch-mobile?workId=" +
        this.workId
      );
    },
    enter() {
      this.$router.push("/account/center");
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
    isFullscreen() {
      return (
        document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        false
      );
    },
  },
};
</script>

<style lang="less" scoped>
.project-detail {
  margin: auto;
  padding: 30px 50px;
  background: #ffffff;
  // width: 800px;
  .scratch-player {
    margin: auto;
    iframe {
      width: 720px;
      height: 600px;
      margin: auto;
      display: block;
    }
  }
  .project-info {
    width: 720px;
    margin: auto;
    display: block;
    text-align: center;
    .project-meta {
      text-align: left;
    }
    .project-op {
      color: #797979;
      padding: 10px 0;
      .anticon {
        font-size: 28px;
      }
      .gap {
        margin-right: 20px;
        font-size: 24px;
      }
    }
  }
  .project-comment {
    border: #e0e0e0 solid 1px;
    padding: 10px;
    .publish {
      .comment-user {
        padding-top: 20px;
      }
      .comment-btn {
        padding-top: 10px;
        button {
          height: 80px;
        }
      }
    }
    .comment-list {
      color: #999;
      border: 1px solid #e9e9e9;
      border-top: none;
      padding: 0 20px;
      .comment-content {
        width: 600px;
      }
      .item {
        padding: 20px;
        font-size: 13px;
        border-bottom: 1px solid #e9e9e9;

        .people {
          font-size: 30px;
        }
        .user {
          color: #666;
          font-size: 14px;
          margin-right: 5px;
        }
        .time {
          font-size: 12px;
        }
        span {
          margin-right: 30px;
        }
        p {
          margin: 10px 0;
        }
      }
      .more {
        font-size: 13px;
        text-align: center;
        padding-top: 40px;
        padding-bottom: 20px;
        > span {
          border: 1px solid #e9e9e9;
          line-height: 47px;
          width: 140px;
          height: 47px;
          display: inline-block;
          color: #999;
        }
      }
    }
  }
}

.ant-layout-sider {
  max-width: 300px !important;
  width: 300px !important;
}

.ant-layout-footer {
  height: 50px;
  bottom: 0;
  width: 100%;
  .copyright {
    text-align: center;
  }
}
</style>